const initialState = {
    loading: false,
    authenticating: false,
}

export default function appState(state = initialState, action) {
    switch (action.type) {
        case 'LOADING':
            return {
                ...state,
                loading: true,
            }

        case 'LOADING_COMPLETE':
            return {
                ...state,
                loading: false,
            }

        case 'AUTHENTICATING':
            return {
                ...state,
                authenticating: true,
            }

        case 'AUTHENTICATING_COMPLETE':
            return {
                ...state,
                authenticating: false,
            }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./app/reducers/appState.js